
import io from 'socket.io-client'
import store from "../redux/store";
import axios from 'axios';

class ChatController {

    constructor(props) {
        this.connected = false;
        this.chatUrl = "";
    }

    connect = async () => {
        if (!this.connected) {
            this.connected = true;
            let data = JSON.parse(localStorage.getItem("fc-logged")),
                parameters = store.getState().parameters,
                hostName = window.location.hostname,
                chatUrl = parameters.chatUrl;

            //! TODO: Trampa
            if (hostName === 'localhost' || hostName === '127.0.0.1' || hostName === "dev.andrei.io")
                chatUrl = "https://devomni.fidelitycloud.es:3000";

            this.chatUrl = chatUrl;
            this.isConnected = this.isConnected.bind(this);
            this.socket = await io.connect(this.chatUrl, { query: `ext=${data.shortExtension}&agt=${data.userId}` });
            this.socket.on('connection-test', this.isConnected);

        }
    }
    disconnect = async () => {
        try {
            if (this.connected) {
                this.connected = false;
                this.socket.disconnect();
            }
        } catch (error) {

        }
    }
    registerInitConversation = (callback) => {
        this.socket.on('initConversation', function (conversation) {
            conversation.interactionType = "chat";
            callback(conversation);
        });
    }

    registerAddMessage = (callback) => {
        this.socket.on('updateUpdateConversation', function (message) {
            callback(message);
        });
    }

    registerCloseConversation = (callback) => {
        this.socket.on('conversationClosed', function (conversationId) {
            callback(conversationId);
        });
    }

    registerTransferChat = (callback) => {
        this.socket.on('chatTransfered', function (conversationId) {
            callback(conversationId);
        });
    }

    registerTransferError = (callback) => {
        this.socket.on('transferError', function (message) {
            callback(message);
        });
    }

    registerUpdateLocation = (callback) => {
        this.socket.on('updateLocation', function (message) {
            callback(message);
        });
    }

    isConnected(data) {
        console.log("*******************\n* SOCKET CONNECTED.\n*******************");
        this.connected = true;
    }

    sendMessage(message) {
        this.socket.emit('addAgentNewMessage', message);
    }

    closeConversation(conversationId) {
        this.socket.emit('closeConversation', conversationId);
    }

    sendSeen(id, userId) {
        axios({
            method: "post",
            url: this.chatUrl + "/seen",
            data: { id: id, userId: userId }
        });
    }

    getChannels(userId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/getTenantChannels",
            data: { pin: userId }
        }).then(res => {
            let data = res.data;
            data = data.sort((a, b) => a.name.localeCompare(b.name));
            callBack(data);
        });
    }

    getGroups(userId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/group/getAgentGroups",
            data: { pin: userId }
        }).then(res => {
            let data = res.data;
            data = data.sort((a, b) => a.name.localeCompare(b.name));
            callBack(data);
        });
    }

    getChannelTemplates(channelId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/getChannelTemplates",
            data: { id: channelId }
        }).then(res => {
            let data = res.data;
            data = data.sort((a, b) => a.name.localeCompare(b.name));
            callBack(data);
        });
    }

    getChannelContacts(channelId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/genericchannel/getcontacts",
            data: { id: channelId }
        }).then(res => {
            let data = res.data;

            callBack(data);
        });
    }

    getFidelityContacts(userId, callBack) {

        axios({
            method: "post",
            url: this.chatUrl + "/contacts",
            data: { pin: userId }
        }).then(res => {
            let data = res.data;
            if (data) {
                data = data.map(x => { return { id: x.Telefono, name: x.Nombre } });
                data = data.sort((a, b) => a.name.localeCompare(b.name));
            } else {
                data = [];
            }
            callBack(data);
        }).catch(x => {
            callBack([]);
        });

    }

    uploadFile(file, callBack) {
        let form = new FormData();
        form.append("file", file);
        axios({
            method: "post",
            url: this.chatUrl + "/uploadfile",
            data: form
        }).then(res => {
            let data = res.data;
            callBack(data);
        });
    }

    sendTemplate(data, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/sendTemplate",
            data: data
        }).then(res => {
            callBack(res);
        });
    }

    sendOutgoingMessage(message, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/sendWhatsAppMessage",
            data: { data: JSON.stringify(message) }
        }).then(res => {
            callBack(res);
        });
    }

    getAgents(userId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/getAgents",
            data: { pin: userId }
        }).then(res => {
            callBack(res);
        });
    }

    initInternal(from, name, to, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/initInternalChat",
            data: { pin: to, name: name, from: from },
        }).then(res => {
            callBack(res);
        });
    }

    loadMessages(id, skip, take, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/getChatHistory",
            data: { id, skip, take },
        }).then(res => {
            callBack(res);
        });
    }

    getFaqCategories(userId, id, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/getAnswersCategories",
            data: { pin: userId, id: id },
        }).then(res => {
            callBack(res);
        });
    }

    getFaqQuestions(categoryId, conversationId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/getQuestionsCategory",
            data: { id: categoryId, conversationId },
        }).then(res => {
            callBack(res);
        });
    }

    getFidelityUrl(userId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/getFidelityUrl",
            data: { pin: userId },
        }).then(res => {
            callBack(res);
        });
    }

    getShortUrl(url, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/app/getShortLink",
            data: { url },
        }).then(res => {
            callBack(res);
        }).catch(x => {
            callBack(null);
        });
    }

    getAvailableAgents(userId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/getAvailableAgents",
            data: { pin: userId }
        }).then(res => {
            callBack(res);
        });
    }

    getAllGroups(userId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/group",
            data: { pin: userId }
        }).then(res => {
            callBack(res);
        });
    }

    transferChat(userId, groupId, conversationId, pin, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/transferChat",
            data: {
                conversationId: conversationId,
                agentId: userId,
                groupId: groupId,
                pin: pin
            },
        }).then(res => {
            callBack(res);
        });
    }

    sendEmail(email, conversationId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/sendEmailFromAgent",
            data: { conversationId: conversationId, email: email },
        }).then(res => {
            callBack(res);
        });
    }

    getLastOcurrenceOfString(conversationId, text, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/getlastocurrenceofstring",
            data: { conversationId: conversationId, value: text },
        }).then(res => {
            callBack(res);
        });
    }

    search(group, search, caller, channel, startdate, enddate, userId, callBack) {

        axios({
            method: "post",
            url: this.chatUrl + "/conversations/searchchats",
            data: { group, search, caller, channel, startdate, enddate, userId },
        }).then(res => {
            callBack(res);
        });
    }

    reopenChat(conversation, callBack) {

        axios({
            method: "post",
            url: this.chatUrl + "/conversations/reopenChat",
            data: conversation,
        }).then(res => {
            callBack(res);
        });
    }

    getChat(id, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/getchat",
            data: {
                "id": id
            },
        }).then(res => {
            callBack(res);
        });
    }
    getChatByGuid(guid, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/getchat",
            data: {
                "guid": guid
            },
        }).then(res => {
            callBack(res);
        });
    }

    setContactProcessed(id, postponed, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/contactProcessed",
            data: {
                "id": id,
                "postponed": postponed
            },
        }).then(res => {
            callBack(res);
        });
    }

    aiEnabled(callBack) {
        axios({
            method: "get",
            url: this.chatUrl + "/ai/enabled",
        }).then(res => {
            callBack(res.data);
        });
    }

    getSummary(data, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/ai/getSummary",
            data: data,
        }).then(res => {
            callBack(res.data);
        }).catch(x => {
            callBack(null);
        });
    }

    getResponse(data, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/ai/getAutoResponse",
            data: data,
        }).then(res => {
            callBack(res.data);
        }).catch(x => {
            callBack(null);
        });
    }

    translate(data, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/ai/translate",
            data: data,
        }).then(res => {
            callBack(res.data);
        }).catch(x => {
            callBack(null);
        });
    }

    toggleAITranslation(data, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/ai/toggleAITranslation",
            data: data,
        }).then(res => {
            callBack(res.data);
        }).catch(x => {
            callBack(null);
        });
    }

    linkEmails(data, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/linkemails",
            data: data,
        }).then(res => {
            callBack(res.data);
        }).catch(x => {
            callBack(null);
        });
    }
    setConverastionBookId(data, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/setConverastionBookId",
            data: data,
        }).then(res => {
            callBack(res.data);
        }).catch(x => {
            callBack(null);
        });
    }
    findContact(data, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/findContact",
            data: data,
        }).then(res => {
            callBack(res.data);
        }).catch(x => {
            callBack(null);
        });
    }
    putOnHold(data, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/putOnHold",
            data: data,
        }).then(res => {
            callBack(res.data);
        }).catch(x => {
            callBack(null);
        });
    }
    askAssistant(data, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/ai/askAssistant",
            data: data,
        }).then(res => {
            callBack(res.data);
        }).catch(x => {
            callBack(null);
        });
    }
    reopenChat(conversation, callBack) {

        axios({
            method: "post",
            url: this.chatUrl + "/conversations/reopenChat",
            data: conversation,
        }).then(res => {
            callBack(res);
        });
    }
    closeConversations(data, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/closeConversations",
            data: data,
        }).then(res => {
            callBack(res.data);
        }).catch(x => {
            callBack(null);
        });
    }
    transferMultiple(userId, groupId, conversations, pin, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/transfer",
            data: { conversations: conversations, agentId: userId, groupId: groupId, pin: pin },
        }).then(res => {
            callBack(res);
        });
    }
    searchInteractions(filters, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/searchInteractions",
            data: filters,
        }).then(res => {
            callBack(res);
        }).catch(x => {
            callBack(null);
        });
    }
    getUsers(userId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/users/",
            data: { userId },
        }).then(res => {
            callBack(res);
        }).catch(x => {
            callBack(null);
        });
    }
    isSearchAll(tenantId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/isSearchAll",
            data: { tenantId },
        }).then(res => {
            callBack(res);
        }).catch(x => {
            callBack(null);
        });
    }
    isTransferAsync(tenantId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/isTransferAsync",
            data: { tenantId },
        }).then(res => {
            callBack(res);
        }).catch(x => {
            callBack(null);
        });
    }
    getTransferGroups(userId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/group/getTransferGroups",
            data: { pin: userId }
        }).then(res => {
            let data = res.data;
            data = data.sort((a, b) => a.name.localeCompare(b.name));
            callBack(data);
        });
    }
    isAnyAgentOnMyGroups(tenantId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/isAnyAgentOnMyGroups",
            data: { tenantId },
        }).then(res => {
            callBack(res);
        }).catch(x => {
            callBack(null);
        });
    }
    getUserTenantAgents(userId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/app/getUserTenantAgents",
            data: { userId },
        }).then(res => {
            let data = res.data;
            data = data.sort((a, b) => a.name.localeCompare(b.name));
            callBack(data);
        }).catch(x => {
            callBack(null);
        });
    }
    getUserTenantGroups(userId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/app/getUserTenantGroups",
            data: { userId },
        }).then(res => {
            let data = res.data;
            data = data.sort((a, b) => a.name.localeCompare(b.name));
            callBack(data);
        }).catch(x => {
            callBack(null);
        });
    }
};

const ChatsService = new ChatController();
export default ChatsService;